import React from 'react';
import { SWRConfig } from 'swr';
import { swrConfig } from '@shared/api/swr/config';

interface SWRProviderProps {
  children: React.ReactNode;
  value?: {
    fetcher?: (key: unknown) => Promise<unknown>;
  };
}

export function SWRProvider({ children, value }: SWRProviderProps): React.ReactElement {
  return (
    <SWRConfig value={{ ...swrConfig, ...value }}>
      {children}
    </SWRConfig>
  );
}
